/**
 * @description 주문현황 및 알림 > 알림 설정 페이지
 */
import { useEffect } from "react";
import { inject, observer } from "mobx-react";

import { partnerIcon } from "utils/Utils";
import { channelAlarmsConfig, deliveryStatusAlarmsConfig } from "views/setting/constants/alarmConfig";
import { SectionTitle } from "components/ui/SectionTitle";
import { fn_change_down_sound, fn_change_up_sound, fn_setSoundPlay, fn_getSoundPlay } from "function/FnBodySetting";
import { fn_bridge_sound_play } from "function/FnPosBridge";

const SoundToggleItem = ({
  type,
  rootStore,
  image,
  id,
  label,
  alarmName,
  checked,
  onChange,
}: {
  type?: string;
  rootStore: any;
  image?: string;
  id: string;
  label: string;
  alarmName: string;
  checked: boolean;
  onChange: () => void;
}) => {
  return (
    <li className={type ?? ""}>
      <div className="tit">
        {image && (
          <span className="img">
            <img src={partnerIcon(image)} alt={label} useMap="#link" width="30px" />
          </span>
        )}
        <label className="play">{label}</label>
        <button className="sound_play" onClick={() => fn_bridge_sound_play(rootStore, alarmName)}>
          <span className="ico"></span>미리듣기
        </button>
        <div className="lab_check a">
          <input type="checkbox" name="aaa" id={id} className="inp" checked={checked} onChange={onChange} />
          <label className="lab_toggle" htmlFor={id}></label>
        </div>
      </div>
    </li>
  );
};
const SettingDefaultUseSoundView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore } = rootStore;
  const soundSettings = fn_getSoundPlay(rootStore);

  useEffect(() => {
    settingStore.setSettingUseMenu("use");
    settingStore.setSettingView(false);
  }, []);

  return (
    <div className="scroll tab">
      <div className="inner">
        <div className="wrap sound">
          <SectionTitle title="알림 볼륨 설정" subTitle="알림음 크기 설정" addBottomBorder />
          <div className="box sound">
            <div className="sound">
              <button
                type="button"
                className="btn_sound_down"
                onClick={event => {
                  event.preventDefault();
                  fn_change_down_sound(rootStore);
                }}
              >
                <span>소리줄이기</span>
              </button>
              <span className={"bg_sound bg_sound" + settingStore.getSoundPlayInfo.soundLevel}></span>
              <button
                type="button"
                className="btn_sound_up"
                onClick={event => {
                  event.preventDefault();
                  fn_change_up_sound(rootStore);
                }}
              >
                <span>소리높이기</span>
              </button>
            </div>
          </div>
          <SectionTitle title="기본 알림" subTitle="배달매니저 사용시 기본 알림" addBottomBorder />
          <div className="box_inner">
            <ul className="sound_message">
              <SoundToggleItem
                key={"basicAlarm"}
                rootStore={rootStore}
                id={"checkbox_basicAlarm"}
                label={"기본 알림"}
                alarmName={"basicAlarm"}
                checked={fn_getSoundPlay(rootStore)["basicAlarm"] === "Y"}
                onChange={() => fn_setSoundPlay(rootStore, "basicAlarm", fn_getSoundPlay(rootStore)["basicAlarm"])}
              />
            </ul>
          </div>
          <SectionTitle title="배달 상태 알림" subTitle="배달 상태 알림 사용 설정" addBottomBorder />
          <div className="box_inner">
            <ul className="sound_message">
              {deliveryStatusAlarmsConfig?.map(alarm => (
                <SoundToggleItem
                  key={alarm.id}
                  rootStore={rootStore}
                  id={alarm.id}
                  label={alarm.label}
                  alarmName={alarm.alarmName}
                  checked={fn_getSoundPlay(rootStore)[alarm.alarmName] === "Y"}
                  onChange={() =>
                    fn_setSoundPlay(rootStore, alarm.alarmName, fn_getSoundPlay(rootStore)[alarm.alarmName])
                  }
                />
              ))}
            </ul>
          </div>
          <SectionTitle title="주문 채널별 신규 주문 알림" subTitle="신규 주문 알림 사용 설정" addBottomBorder />
          <div className="box_inner">
            <ul className="sound_message last">
              {channelAlarmsConfig?.map(alarm => (
                <SoundToggleItem
                  key={alarm.id}
                  type={alarm.type}
                  rootStore={rootStore}
                  image={alarm.image}
                  id={alarm.id}
                  label={alarm.label}
                  alarmName={alarm.alarmName}
                  checked={soundSettings[alarm.alarmName] === "Y"}
                  onChange={() => fn_setSoundPlay(rootStore, alarm.alarmName, soundSettings[alarm.alarmName])}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(SettingDefaultUseSoundView));
